<template>
  <div>
    <el-link type="primary" :underline="false" @click="dialogVisible = true"
      ><slot></slot
    ></el-link>
    <el-dialog
      :title="`${item.name}（${item.code}）历史记录信息`"
      :visible.sync="dialogVisible"
      width="1000px"
      :append-to-body="true"
      custom-class="small"
      @open="handleOpen"
    >
      <template v-if="!loading">
        <el-descriptions title="" size="small">
          <el-descriptions-item label="名称">{{
            item.name
          }}</el-descriptions-item>
          <el-descriptions-item label="编号">{{
            item.code
          }}</el-descriptions-item>
          <el-descriptions-item label="型号">{{
            item.model_number
          }}</el-descriptions-item>
          <el-descriptions-item
            label="整机编号"
            v-if="item.status == 2 && item.product.id"
          >
            <ProductLink :product="item.product"></ProductLink>
          </el-descriptions-item>
          <el-descriptions-item
            :label="param.label"
            v-for="param in item.custom_params"
            :key="param.key"
          >
            {{ param.value }}
          </el-descriptions-item>
          <el-descriptions-item label="期初使用时间">{{
            item.start_man_hour
          }}</el-descriptions-item>
          <el-descriptions-item label="使用次数">{{
            item.used_count
          }}</el-descriptions-item>
          <el-descriptions-item label="维修次数">{{
            item.repair_count
          }}</el-descriptions-item>
          <el-descriptions-item label="预测寿命">{{
            item.age
          }}</el-descriptions-item>
          <el-descriptions-item label="总工作时长">{{
            item.total_man_hour
          }}</el-descriptions-item>
          <el-descriptions-item label="组装基地">
            {{ item.install_base.name }}
          </el-descriptions-item>
          <el-descriptions-item label="发往基地" v-if="item.category == 1">
            {{ item.base.name }}
          </el-descriptions-item>
          <el-descriptions-item label="库存基地" v-if="item.category == 2">
            <div>
              {{ item.base.name }}
            </div>
            <div class="text-danger" v-if="item.receive_base_id">
              {{ `（待${item.receive_base.name}入库）` }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="发往钻井" v-if="item.category == 2">
            <div>
              {{ item.drill_well.well_number || '无' }}
            </div>
            <div class="text-danger" v-if="item.drill_well_receive_status">
              {{
                `（待${
                  item.drill_well_receive_status == 1 ? '钻井' : '基地'
                }接收）`
              }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="状态">
            <ItemStatus :status="item.status"></ItemStatus>
          </el-descriptions-item>
          <el-descriptions-item label="备注">
            {{ item.remark }}
          </el-descriptions-item>
        </el-descriptions>

        <el-button
          v-permission="
            item.category == 1 ? Auth.itemEdit : Auth.instrumentItemEdit
          "
          type="primary"
          size="small"
          plain
          @click="editItem"
          >编辑</el-button
        >

        <el-tabs v-if="dialogVisible" class="mt-10">
          <el-tab-pane label="使用记录">
            <ItemRecords
              :item="item"
              :category="5"
              v-if="item.id"
            ></ItemRecords>
          </el-tab-pane>
          <el-tab-pane label="维修记录">
            <ItemRecords
              :item="item"
              :hideAddBtn="true"
              :category="6"
              v-if="item.id"
            ></ItemRecords>
          </el-tab-pane>
          <el-tab-pane label="附件列表">
            <AttachmentTable :item="item"></AttachmentTable>
          </el-tab-pane>
          <el-tab-pane label="操作日志">
            <ItemRecords :item="item" v-if="item.id"></ItemRecords>
          </el-tab-pane>
        </el-tabs>
      </template>
    </el-dialog>
    <ItemFormer
      v-permission="
        item.category == 1 ? Auth.itemEdit : Auth.instrumentItemEdit
      "
      :model="editModel"
      :show.sync="formerVisible"
      @updated="updatedCallback"
    ></ItemFormer>
  </div>
</template>

<script>
import ItemRecords from '@/views/items/item_records'
import { itemDetail } from '../service/getData'
import ItemFormer from '@/views/items/former'
import AttachmentTable from '@/views/items/attachment.vue'

export default {
  components: {
    ItemRecords,
    ItemFormer,
    AttachmentTable,
  },
  props: {
    model: {
      type: Object,
      default: () => ({ name: '', code: '' }),
    },
  },
  data: function () {
    return {
      dialogVisible: false,
      item: null,
      loading: true,
      formerVisible: false,
      editModel: {},
    }
  },
  created() {
    this.item = this.model
  },
  methods: {
    async handleOpen() {
      // if (!this.model.hasOwnProperty('category')) {
      this.loading = true
      let res = await itemDetail(this.model.id)
      if (res.code == 0) {
        this.item = res.data
        this.loading = false
      }
      // } else {
      //   this.item = this.model
      //   this.loading = false
      // }
    },

    editItem() {
      this.editModel = this.clone(this.item)
      this.editModel.custom_params = this.copyCustomParam(
        this.item.template.custom_params,
        this.item.custom_params,
      )
      this.formerVisible = true
    },
    updatedCallback(data) {
      this.item = data
    },
  },
}
</script>